import { useMutation } from '@apollo/client'
import { DestroyStepDocument, GetProcessDetailDocument } from 'generated/resources/graphql'

export const useDestroyStep = () => {
  const [executeMutation] = useMutation(DestroyStepDocument)

  const destroyStep = async (id: number, processId: number) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.destroyProcessesStep?.errors.length) {
      throw (
        'Could not destroy step: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.destroyProcessesStep?.errors || []),
        ])
      )
    }
  }

  return {
    destroyStep,
  }
}
